import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import size from "lodash/size";
import { NAMESPACE, NEW_PROJECT } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: { draft: {}, data: undefined, projectId: undefined }
};
export default createReducer(initialState, {
    [actionTypes.SET_DRAFT]: (state, { draft }) => {
        const isDraftPartial = size(draft) === 1;
        return set(state, `[${NAMESPACE}].draft`, isDraftPartial && draft ? { ...state[NAMESPACE].draft, ...draft } : draft, {
            checkExistence: false,
            checkEqual: false
        });
    },
    [actionTypes.GET_PROJECT_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].data`, payload),
    [actionTypes.SET_PROJECT_ID]: (state, { projectId }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            projectId,
            data: projectId === undefined ? undefined : state[NAMESPACE].data,
            draft: projectId === undefined ? {} : state[NAMESPACE].draft
        }
    }),
    [actionTypes.SET_NEW_PROJECT]: (state, { workSpaceId }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            projectId: NEW_PROJECT.Id,
            data: { ...NEW_PROJECT, WorkSpaceId: workSpaceId },
            draft: {}
        }
    })
});
